(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuyGiftCardController', BuyGiftCardController);

    BuyGiftCardController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'localization'];

    function BuyGiftCardController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, localization) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.selectAmount = selectAmount;
        vm.toCheckout = toCheckout;
        vm.userCurrency = "dkk";
        vm.getOrderFee = getOrderFee;
        vm.getTotal = getTotal;

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Køb gavekort – Be My Concert" : "Buy gift card – Be My Concert";
            localization.getLocation().then(function(location) {
                vm.location = location;
                if(location == "Sweden") {
                    vm.userCurrency = "sek";
                }
                getOrderFee();
            })
        }

        function toCheckout() {
            var checkoutData = {
                gift_card_amount: vm.gift_card_amount,
                currency: vm.userCurrency
            };

            $http.post('/app/api/checkout/create/buy_gift_card/', checkoutData)
                .then(function (response) {
                    var checkout_id = parseInt(response.data)
                    if (vm.gift_card_amount > 0) {
                        $state.go('checkout', { checkout_id: checkout_id});
                    }
            });
        }

        // function getUserCurrency(){
        //     $http.get('/app/api/users/private/currency')
        //         .then(function (response) {
        //             vm.userCurrency = response.data;
        //     });
        // }

        function selectAmount(amount){
            vm.gift_card_amount = amount;
        }

        function getTotal(){
            return vm.gift_card_amount + vm.orderFee;
        }

        function getOrderFee(){
            vm.orderFee = 20.00;
        }

        function close() {
            return $state.go('gift_card_guide');
        }

    }
})();